<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-my-submissions">
  <div class="consumer-my-submissions--layout">
    <app-consumer-sidebar class="consumer-my-submissions--sidebar"></app-consumer-sidebar>
    <div class="consumer-my-submissions--content">
      <app-page-header></app-page-header>
      <div class="my-submissions--container">
        <app-my-submissions [showPanelHeader]="false"></app-my-submissions>
      </div>
    </div>
  </div>
</div>
